import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorNotification {
  name: string;
  id: string | null;
  code: number | null;
  message: string;
  stack: string | null;
  info: string | null;
  logout: boolean;
}

interface ErrorState {
  errorNotifications: ErrorNotification[];
}

const initialState: ErrorState = {
  errorNotifications: [],
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    showNotification(state, { payload }: PayloadAction<ErrorNotification>) {
      state.errorNotifications.push(payload);
    },
    closeNotification(state) {
      state.errorNotifications.splice(0, 1);
    },
  },
});

export const errorReducer = errorSlice.reducer;

export default errorSlice.actions;
